import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { StaticImage } from 'gatsby-plugin-image';
import Slider from "react-slick";
import MarketoFormComponent from '../marketo/marketoFormComponent';
import proRight from '../../images/arrow-pro-right.svg';
import proRightWhite from '../../images/arrow-right-white.svg';
import proRightTextLinkBlue from '../../images/arrow-pro-right.svg';
import '../../sass/components/flexibleModules/_components.genericTwoColumnMastheadSectionWithGrid.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";
import rightArrow from '../../images/arrow-right-white.svg';
import tboButtonWhite from '../../images/play-button-circled-v2-white.svg';
import logoPlanful from '../../images/planful-logo-latest-svg.svg';
import logoTrintech from '../../images/logo-trintech.svg';

const GenericTwoColumnMastheadSectionWithGrid = ({ data }) => {
    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 3000,
        slidesToShow: 6,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
        if (data.genericTwoColumnMastheadSectionWithGridImageOrVideo === 'video') {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/w2u6tep9ji.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    const [videoShow, setVideoShow] = useState(false);
    const showVideo = (val) => {
        setVideoShow(val);
    }

    const [marketoFormShow, setMarketoFormShow] = useState(false);
    const showMarketoForm = (val) => {
        setMarketoFormShow(val);
    }

    const scrollToRef = (ref) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    const scrollToRefAlt = (ref, index) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
            document.querySelector(`.cp-halfaHalfSectionWithAccordion__right-accordion:nth-child(${index}) > button`).click();
        }
    }

    if (data.genericTwoColumnMastheadSectionWithGridLottie === 'yes' && typeof document !== "undefined") {
        var scriptOne = document.createElement('script');
        scriptOne.src = 'https://unpkg.com/@lottiefiles/lottie-player@2.0.12/dist/lottie-player.js';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
    }

    const [muted, setMuted] = useState(false);
    const [played, setPlayed] = useState(true);

    const videotrigger = (val, id) => {
        if (typeof window !== 'undefined') {
            var video = window.Wistia.api(`wistia-${id}-1`);
            if (val === 'unmute') {
                video.unmute();
                setMuted(true);
            }
            else if (val === 'mute') {
                video.mute();
                setMuted(false);
            }
            else if (val === 'play') {
                video.play();
                setPlayed(true);
            }
            else if (val === 'pause') {
                video.pause();
                setPlayed(false);
            }
            else {
                video.time(video.time() - 5);
            }
        }
    }

    return (
        <div className={`cp-genericGridTwoColumnMastheadGrid l-${data.textColor} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}`, margin: "0 auto" }}>
            <div className="cp-genericGridTwoColumnMastheadGrid__inner">
                <span className="l-patternOne l--absolute"></span>
                <span className="l-patternTwo l--absolute"></span>
                <span className="l-patternThree l--absolute"></span>
                {/* {data.overrideClass === "l-stateOfMarketing" &&
                    <>
                        <span className="l-absoluteIcon l-absoluteIcon1">
                            <StaticImage src="../../images/Rectangle 1107.svg" alt="pattern" />
                        </span>
                        <span className="l-absoluteIcon l-absoluteIcon2">
                            <StaticImage src="../../images/Rectangle 1111.svg" alt="pattern" />
                        </span>
                        <span className="l-absoluteIcon l-absoluteIcon3">
                            <StaticImage src="../../images/Rectangle 1112.svg" alt="pattern" />
                        </span>
                        <span className="l-absoluteIcon l-absoluteIcon4">
                            <StaticImage src="../../images/Ellipse 4.svg" alt="pattern" />
                        </span>
                        <span className="l-absoluteIcon l-absoluteIcon5">
                            <StaticImage src="../../images/Ellipse 3.svg" alt="pattern" />
                        </span>
                    </>
                }
                {data.overrideClass &&
                    <>
                        {data.overrideClass.includes('l-newPatterns') &&
                            <>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon1">
                                    <StaticImage src="../../images/icon-yellow-new-v2.png" alt="pattern" />
                                </span>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon2">
                                    <StaticImage src="../../images/iconnew-green-new-v2.png" alt="pattern" />
                                </span>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon3">
                                    <StaticImage src="../../images/iconnew-utraviolet-new-v2.png" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                }
                {data.overrideClass &&
                    <>
                        {data.overrideClass.includes('l-surpriselp') &&
                            <>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon1">
                                    <StaticImage src="../../images/green-circle-pattern.svg" alt="pattern" />
                                </span>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon2">
                                    <StaticImage src="../../images/svgpattern2.svg" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                }
                {data.overrideClass &&
                    <>
                        {data.overrideClass === 'l-patternlatest' &&
                            <>
                                <span className="l-absoluteIcon l-absoluteIcon1">
                                    <StaticImage src="../../images/yellow-latest-pattern.svg" alt="pattern" />
                                </span>
                                <span className="l-absoluteIcon l-absoluteIcon2">
                                    <StaticImage src="../../images/purple-latest-pattern.svg" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                } */}
                {data.overrideClass &&
                    <>
                        {data.overrideClass.includes('l-newpowerbi') &&
                            <>
                                <span className="l-absolutePatternpowerbi">
                                    <StaticImage src="../../images/BG_Patterns_1550x1400.png" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                }
                <div className="l--content l--flex" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                    <div className="cp-genericGridTwoColumnMastheadGrid__left">
                        {data.overrideClass &&
                            <>
                                {data.overrideClass === 'l-gradient-detect' &&
                                    <span className="l-subHead">PLANFUL AI DETECT</span>
                                }
                                {data.overrideClass === 'l-gradient-forecast' &&
                                    <span className="l-subHead">PLANFUL AI FORECAST</span>
                                }
                                {data.overrideClass === 'l-gradient-help' &&
                                    <span className="l-subHead">PLANFUL AI HELP</span>
                                }
                                {data.overrideClass.includes('l-trintech') &&
                                    <div className="l--trin l--flex">
                                        <img src={logoPlanful} alt="" />
                                        <span className="l-divider"></span>
                                        <img src={logoTrintech} alt="" />
                                    </div>
                                }
                                {data.overrideClass.includes('l--nobg') &&
                                    <span className="l-subHead">MEET WORKFORCE PRO</span>
                                }
                            </>
                        }
                        {data.genericTwoColumnMastheadSectionWithGridHeader &&
                            <h1 dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadSectionWithGridHeader }} />
                        }
                        {data.genericTwoColumnMastheadSectionWithGridTeaser &&
                            <p dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadSectionWithGridTeaser }} />
                        }
                        {data.genericTwoColumnMastheadSectionWithGridStarImage &&
                            <div className="l-starrating l--flex">
                                {data.genericTwoColumnMastheadSectionWithGridStarImage &&
                                    <img loading="lazy" src={data.genericTwoColumnMastheadSectionWithGridStarImage.sourceUrl} alt={data.genericTwoColumnMastheadSectionWithGridStarImage.altText} />
                                }
                                <span>163</span>
                            </div>
                        }
                        {data.genericTwoColumnMastheadSectionWithGridButton &&
                            <>
                                {data.genericTwoColumnMastheadSectionWithGridButton.url === '#cp-marketoFormFlexiComponent' ?
                                    <button onClick={() => scrollToRef(`.cp-marketoFormFlexiComponent`)} className="l-button l-marketo">
                                        <span>{data.genericTwoColumnMastheadSectionWithGridButton.title}</span>
                                        {data.textColor === 'light' ?
                                            <img loading="lazy" src={proRight} alt="" />
                                            :
                                            <img loading="lazy" src={proRightWhite} alt="" />
                                        }
                                    </button>
                                    :
                                    data.genericTwoColumnMastheadSectionWithGridButton.url === '#cp-marketoFormABTest' ?
                                        <button onClick={() => showMarketoForm(true)} className="l-button l-marketo">
                                            <span>{data.genericTwoColumnMastheadSectionWithGridButton.title}</span>
                                            {data.textColor === 'light' ?
                                                <img loading="lazy" src={proRight} alt="" />
                                                :
                                                <img loading="lazy" src={proRightWhite} alt="" />
                                            }
                                        </button>
                                        :
                                        data.genericTwoColumnMastheadSectionWithGridButton.url === '#manager' ?
                                            <button onClick={() => scrollToRef(`.cp-smileyContent`)} className="l-button">
                                                <span>{data.genericTwoColumnMastheadSectionWithGridButton.title}</span>
                                                {data.textColor === 'light' ?
                                                    <img loading="lazy" src={proRight} alt="" />
                                                    :
                                                    <img loading="lazy" src={proRightWhite} alt="" />
                                                }
                                            </button>
                                            :
                                            <div className="l-relativeButton">
                                                <a className="l-button" href={data.genericTwoColumnMastheadSectionWithGridButton.url} target={data.genericTwoColumnMastheadSectionWithGridButton.target}>
                                                    <span>{data.genericTwoColumnMastheadSectionWithGridButton.title}</span>
                                                    {data.textColor === 'light' ?
                                                        <img loading="lazy" src={proRight} alt="" />
                                                        :
                                                        <img loading="lazy" src={proRightWhite} alt="" />
                                                    }
                                                </a>
                                                <a className="l-button l-backgroundHover" href={data.genericTwoColumnMastheadSectionWithGridButton.url} target={data.genericTwoColumnMastheadSectionWithGridButton.target}>
                                                    <span>{data.genericTwoColumnMastheadSectionWithGridButton.title}</span>
                                                    {data.textColor === 'light' ?
                                                        <img src={proRight} alt="" />
                                                        :
                                                        <img src={proRightWhite} alt="" />
                                                    }
                                                </a>
                                            </div>
                                }
                            </>
                        }
                        {data.genericTwoColumnMastheadSectionWithGridButtonTwo &&
                            <a className="l--inline l-textlink" href={data.genericTwoColumnMastheadSectionWithGridButtonTwo.url} target={data.genericTwoColumnMastheadSectionWithGridButtonTwo.target}>
                                <span>{data.genericTwoColumnMastheadSectionWithGridButtonTwo.title}</span>
                                <img loading="lazy" src={proRightTextLinkBlue} alt="" />
                            </a>
                        }
                        {data.genericTwoColumnMastheadSectionWithGridLogos &&
                            <div className="cp-ratingLogos l--flex">
                                {data.genericTwoColumnMastheadSectionWithGridLogos.map((logoItem, index) => (
                                    <React.Fragment key={index}>
                                        <img loading="lazy" src={logoItem.logo.sourceUrl} alt={logoItem.logo.altText} />
                                    </React.Fragment>
                                ))}
                            </div>
                        }
                    </div>
                    <div className={`cp-genericGridTwoColumnMastheadGrid__right l--${data.genericTwoColumnMastheadSectionWithGridImageOrVideo}`}>
                        {data.genericTwoColumnMastheadSectionWithGridHeader &&
                            <h2 className="l-mobileOnly" dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadSectionWithGridHeader }} />
                        }
                        {data.genericTwoColumnMastheadSectionWithGridMarketoForm === 'yes' ?
                            <div className="cp-marketoFormComponent">
                                {data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormHeader &&
                                    <h2 dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormHeader }} />
                                }
                                {data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormTeaser &&
                                    <p dangerouslySetInnerHTML={{ __html: data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormTeaser }} />
                                }
                                {data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormId &&
                                    <MarketoFormComponent formSubmitPdf={data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormPdf} wistiaVideoId={data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormWistiaVideoId} ctaOverride={data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormCtaOverride} formSubmitMessage={data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormSubmitMessage} formId={data.genericTwoColumnMastheadSectionWithGridMarketoSection.genericTwoColumnFormId} />
                                }
                            </div>
                            :
                            <>
                                {data.genericTwoColumnMastheadSectionWithGridLottie === 'yes' ?
                                    <lottie-player src={data.genericTwoColumnMastheadSectionWithGridLottieLink} background="transparent" speed="1" autoplay></lottie-player>
                                    :
                                    <>
                                        {data.genericTwoColumnMastheadSectionWithGridImageOrVideo === 'image' ?
                                            <>
                                                {data.genericTwoColumnMastheadSectionWithGridImageLink ?
                                                    <a className="l--trigger" href={data.genericTwoColumnMastheadSectionWithGridImageLink.url} target={data.genericTwoColumnMastheadSectionWithGridImageLink.target}>
                                                        {data.genericTwoColumnMastheadSectionWithGridImage &&
                                                            <GatsbyImage image={data.genericTwoColumnMastheadSectionWithGridImage.gatsbyImage} alt={data.genericTwoColumnMastheadSectionWithGridImage.altText} />
                                                        }
                                                        <span className="l--trigger__absolute l--flex">
                                                            <span>{data.genericTwoColumnMastheadSectionWithGridImageLink.title}</span>
                                                            <img loading="lazy" src={rightArrow} alt="" />
                                                        </span>
                                                    </a>
                                                    :
                                                    <>
                                                        {data.genericTwoColumnMastheadSectionWithGridImage &&
                                                            <GatsbyImage image={getImage(data.genericTwoColumnMastheadSectionWithGridImage.gatsbyImage)} alt={data.genericTwoColumnMastheadSectionWithGridImage.altText} />
                                                        }
                                                    </>
                                                }
                                            </>
                                            :
                                            <>
                                                {data.genericTwoColumnMastheadSectionWithGridVideo &&
                                                    <>
                                                        {/* <div className={`wistia_embed wistia_async_${data.genericTwoColumnMastheadSectionWithGridVideo}`}>&nbsp;</div> */}
                                                        {/* TEST FOR VIDEO <button onClick={() => showVideo(true)} className={`l-button l--flex ${videoShow ? "l--buttonActive" : "l--buttonInactive"}`}>
                                                    <div className="l-relative">
                                                        {data.overrideClass === 'l-videoBlock' ?
                                                            <span className="l-absolute"><StaticImage src="../../images/play-icon-video-block.svg" alt=""></StaticImage><span className="l-hoverShow">Watch Video</span></span>
                                                            :
                                                            <span className="l-absolute"><StaticImage src="../../images/play-icon-video-block-gray.svg" alt=""></StaticImage></span>
                                                        }

                                                        {data.genericTwoColumnMastheadSectionWithGridImage &&
                                                            <GatsbyImage image={getImage(data.genericTwoColumnMastheadSectionWithGridImage.gatsbyImage)} alt={data.genericTwoColumnMastheadSectionWithGridImage.altText} />
                                                        }
                                                    </div>
                                                </button> */}
                                                        {data.overrideClass ?
                                                            <>
                                                                {data.overrideClass.includes('l--graphicHeader') ?
                                                                    <>
                                                                        <button className={`${!videoShow ? "l--active" : "l--inactive"}`} onClick={() => showVideo(true)}>
                                                                            <div className="l-relative">
                                                                                <span className="l-absolute l--flex">
                                                                                    <img loading="lazy" src={tboButtonWhite} alt="" />
                                                                                    {process.env.GATSBY_LANG === "de" ?
                                                                                        <span>Video abspielen</span>
                                                                                        :
                                                                                        <span>Play Video</span>
                                                                                    }
                                                                                </span>
                                                                                {data.genericTwoColumnMastheadSectionWithGridImage &&
                                                                                    <GatsbyImage image={getImage(data.genericTwoColumnMastheadSectionWithGridImage.gatsbyImage)} alt={data.genericTwoColumnMastheadSectionWithGridImage.altText} />
                                                                                }
                                                                            </div>
                                                                        </button>
                                                                        <div className={`cp-wistiaVideoInline ${videoShow ? "l--active" : "l--inactive"}`}>
                                                                            <div className={`wistia_embed wistia_async_${data.genericTwoColumnMastheadSectionWithGridVideo} muted=false autoPlay=true`}>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <div className={`cp-wistiaVideoInline ${videoShow ? "l--active" : "l--active"}`}>
                                                                        <div className={`wistia_embed wistia_async_${data.genericTwoColumnMastheadSectionWithGridVideo} muted=false autoPlay=false`}>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                            :
                                                            <div className={`cp-wistiaVideoInline ${videoShow ? "l--active" : "l--active"}`}>
                                                                <div className={`wistia_embed wistia_async_${data.genericTwoColumnMastheadSectionWithGridVideo} muted=false autoPlay=false`}>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                    </div>
                </div>
                {
                    data.genericTwoColumnMastheadSectionWithGridRepeater &&
                    <div className={`cp-flexibleMastheadGrid ${data.genericTwoColumnMastheadSectionWithGridCarouselCheck === 'yes' ? 'l--block l--carousel' : 'l--flex'}`} style={{ backgroundColor: `${data.mastheadGridRepeaterBackgroundColor}` }} >
                        {data.genericTwoColumnMastheadSectionWithGridLogosHeader &&
                            <h4>{data.genericTwoColumnMastheadSectionWithGridLogosHeader}</h4>
                        }
                        <div className={`cp-flexibleMastheadGrid__inner ${data.genericTwoColumnMastheadSectionWithGridCarouselCheck === 'yes' ? 'l--block l--carousel' : 'l--flex'}`} >
                            {
                                data.genericTwoColumnMastheadSectionWithGridCarouselCheck === 'yes' ?
                                    <>
                                        {isRendered &&
                                            <Slider {...settings}>
                                                {data.genericTwoColumnMastheadSectionWithGridRepeater.map((gridItems, index) => (
                                                    <React.Fragment key={index}>
                                                        <div className="l-gridLogos" key={index}>
                                                            {gridItems.logo &&
                                                                <img src={gridItems.logo.sourceUrl} alt={gridItems.logo.altText} />
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </Slider>
                                        }
                                    </>
                                    :
                                    <>
                                        {data.genericTwoColumnMastheadSectionWithGridRepeater.map((logoItem, index) => (
                                            <React.Fragment key={index}>
                                                {data.overrideClass ?
                                                    <>
                                                        {data.overrideClass.includes('l-logosHomepage') ?
                                                            <>
                                                                {logoItem.logo &&
                                                                    <img width="250" height="68" loading="lazy" src={logoItem.logo.sourceUrl} alt={logoItem.logo.altText} />
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {logoItem.logo &&
                                                                    <GatsbyImage image={getImage(logoItem.logo.gatsbyImage)} alt={logoItem.logo.altText} />
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        {logoItem.logo &&
                                                            <GatsbyImage image={getImage(logoItem.logo.gatsbyImage)} alt={logoItem.logo.altText} />
                                                        }
                                                    </>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </>
                            }
                        </div>
                    </div>
                }

                {marketoFormShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3567" />
                            <button onClick={() => showMarketoForm(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }

                { /* Addition of three section just for H2 surprise LP */}
                {data.threeColumnUniqueGrid &&
                    <div className="cp-surpriseGrid">
                        <div className="cp-surpriseGrid__inner l--flex">
                            {data.threeColumnUniqueGrid.map((gridItem, index) => (
                                <div className="cp-surpriseGrid__section l--flex" key={index}>
                                    <div>
                                        {gridItem.header && gridItem.link &&
                                            <button><span>{gridItem.header}</span><StaticImage src="../../images/arrow-right.svg" alt="arrow" /></button>
                                        }
                                        {gridItem.teaser &&
                                            <p dangerouslySetInnerHTML={{ __html: gridItem.teaser }} />
                                        }
                                    </div>
                                    {gridItem.image &&
                                        <div className="cp-surpriseGrid__section-image" style={{ backgroundColor: `${gridItem.imageBackgroundColor}` }}>
                                            <GatsbyImage image={getImage(gridItem.image.gatsbyImage)} alt={gridItem.image.altText} />
                                        </div>
                                    }
                                    <button onClick={() => scrollToRefAlt(`.cp-halfaHalfSectionWithAccordion__inner`, (index + 1))} className="l-absolute">{gridItem.header}</button>
                                </div>
                            ))}
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}

export default GenericTwoColumnMastheadSectionWithGrid;